module.exports = __webpack_public_path__ + "media/images/icons/working_without_contracts-a991eecdb7f0c5bd25265daa5ec3d24e.svg";